import {BoxProps} from '@chakra-ui/react';
import {CashIcon, CoinsBagIcon, GiftIcon} from '../icons';

export const PrizeIcon = ({type, ...props}: {type: Prize['type']} & BoxProps) => {
  switch (type) {
    case 'cash':
      return <CashIcon {...props} />;
    case 'physical':
      return <GiftIcon {...props} />;
    case 'coins':
    default:
      return <CoinsBagIcon {...props} />;
  }
};
